/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { Components } from './components';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface AddReleaseSpec { 
    /**
     * Release Version String
     */
    version: string;
    release_type: ReleaseTypeEnum;
    service_type: ServiceTypeEnum;
    cloud_provider?: CloudProviderEnum;
    persona?: VcdsPersonaEnum;
    /**
     * Upgrade Allowed from these releases
     */
    upgrade_from?: Array<string>;
    components: Components;
    /**
     * List of org ids having access to release
     */
    access_list?: Array<string>;
    /**
     * Capability values of a release
     */
    capability?: { [key: string]: string; };
    /**
     * Comments/Notes regarding this release
     */
    notes?: string;
    /**
     * If true (default false), skip some validation to load this release in SaaSInfra.
     */
    skip_validation?: boolean;
}
export namespace AddReleaseSpec {
}


